import React, { useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardContent,
  Modal,
  IconButton,
  Typography,
  Tooltip,
  Grid,
  TextField,
  Alert, 
  AlertTitle, 
  AlertProps,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { downloadNoteCSV } from "../../utils/GetAdmin";
import { uploadNoteCSV,approveNoteCSV } from "../../utils/PostAdmin"
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import {
  Lock,
  GetApp,
  ExpandMore,
  Attachment,
  Publish,
  Save,
  AddCircle,
  RemoveCircle,
  Help,
  Clear,
 } from '@mui/icons-material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    card: {
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    input: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}
export default function AdminBanks() {
  const classes = useStyles();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [codes, setCodes] = React.useState<any>();
  
  const [modalStyle] = React.useState(getModalStyle);
  const [alertLevel, setAlertLevel] = React.useState<AlertProps>({severity:"info"});
  const [alertTitle, setAlertTitle] = React.useState<string>();
  const [alertMessage, setAlertMessage] = React.useState<string>();
  const [fileName, setfileName] = React.useState<string>();
  const [openAlertWindow, setOpenAlertWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenAlertWindow(false);
  }
  
  const enabled = checkForRole(clientId,salesOrg,'vp_admin_bulk');

  const [selectedFile, setSelectedFile] = React.useState<File>();
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [bulkSummary, setBulkSummary] = React.useState<{valid:number,invalid:number}>();
  const [bulkADD, setBulkADD] = React.useState<{salesOffice:string, customerNum:string, noteType:string, validUntilDt:string, text:string}[]>();
  const [bulkKeyId, setBulkKeyId] = React.useState<string>();
  const [bulkMessage, setBulkMessage] = React.useState<string>();
  const [bulkErrorBody, setBulkErrorBody] = React.useState<any>();
  
  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES","cust_note_type"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
            setDoneLoading(true);
        });
  }, [selectedFile,doneLoading,bulkKeyId,bulkErrorBody]);
  return ( 
      enabled ? (
    <div className={classes.root}>
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
      <Typography variant="h4" className={classes.paragraph}>
        Admin Bulk Notes
      </Typography>
      <Typography
        variant="subtitle1"
        className={classes.paragraphAct}
        paragraph
      >
        This page allows you to bulk create notes for VendPrime and VendSmart. 
        <strong>Use this tool with caution as you will need to manually delete once created. </strong> 
      </Typography>
      <Grid container spacing={2} className={classes.primary}>
          <Grid item xs={12} md={12} xl={12}>
            <Accordion className={classes.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h5" className={classes.paragraph}>
                  <Help /> How to Use
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                
                <Card className={classes.card}>
                  <CardContent>
                    <Typography
                      variant="subtitle1"
                      className={classes.paragraphAct}
                      paragraph
                    >
                      First download the template file with sample data. This data is provided as an example, and should be deleted before uploading. 
                      The notes to be created should follow the same formatting. Make your modifications to the downloaded csv file. 
                    </Typography>
                  <Typography
                    variant="subtitle1"
                    className={classes.paragraphAct}
                    paragraph
                  >
                    After you are done making your changes, upload the file. You will be shown how 
                    many notes will be created and will be asked to confirm the action. Once you have confirmed, 
                    the changes will be applied to the application's database. At this point, the only way to 
                    delete the notes that were created is to open each customer and remove the note.
                  </Typography>
                  </CardContent>
                </Card>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <Card className={classes.card}>
              <CardContent>
              <Typography variant="h5" className={classes.paragraph}>
                Stage Changes
              </Typography>
                <div>
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.paragraphButton}
                    onClick={(event) => {
                        downloadNoteCSV(salesOrg).then( reply => {
                          const url = window.URL.createObjectURL( new Blob([reply.data], {type: 'text/csv'}));
                          const link = document.createElement('a');
                          link.href = url;
                          link.setAttribute('download', `NOTES_Template.csv`);
                          document.body.appendChild(link);
                          link.click();
                        })
                      }
                    }
                  >
                    <GetApp/> Get Template
                  </Button>
                </div>
                <br/>
                <div className={classes.divWidth}>
                    <Button
                      color="primary"
                      component="label"
                      variant="contained"
                      style={{marginRight:10}}
                      className={classes.paragraphButton}>
                      <Attachment style={{marginRight:3}} /> Select File
                      <input type="file" name="banks" id='bank-file' 
                        hidden
                        onChange={(e) => {
                          setSelectedFile(undefined)
                          if(e.target.files){
                            setSelectedFile(e.target.files[0]);
							setfileName(e.target.files[0].name);
							e.target.value = "";
                          } 
                        }
                      }/>
                    </Button>
                    <TextField placeholder='File' type='text' value={fileName} />
                  </div>
                  <br/>
                    <Button
                        color="primary"
                        variant="contained"
                        className={classes.paragraphButton}
                        disabled={(selectedFile)?false:true}          
                        onClick={(event) => {
                            if(selectedFile){
                              setBackdropLoader(true)
                              setBulkSummary(undefined);
                              setBulkADD(undefined);
                              setBulkMessage(undefined);
                              setBulkKeyId(undefined);
                              uploadNoteCSV(salesOrg,selectedFile).then((result) => {
                                setBackdropLoader(false)
                                if(result && result.status < 400){
                                  if(result.data.noteDelta){
                                    setBulkSummary(result.data.noteDelta.counts);
                                    setBulkADD(result.data.noteDelta.ADD);
                                    setBulkKeyId(result.data.keyId);
                                    setBulkErrorBody(undefined);
                                  }
                                } else {
                                  setBulkErrorBody(result?.data || {error:"UNKNOWN ERROR"});
                                }
                                let message:string = result?.data?.message || 'An UNKNOWN ERROR occured! This may have been caused by modifying the file after selecting it. Please try renaming the file, then uploading the renamed file again. If this does not resolve, please reach out to CONA Services with an incident.'
                                setBulkMessage(message);
                              })
                            }
                          }
                        }
                      >
                        <Publish/> Upload
                    </Button>
                </CardContent>
              </Card>
            </Grid>
                {
                  (bulkMessage && !bulkErrorBody)?( /* Upload Detected */
                    <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                      <Card className={classes.card}>
                        <CardContent>
                          <Typography variant="h5" className={classes.paragraph}>
                            Approve Changes
                          </Typography>
                          <Typography
                            variant="subtitle1"
                            className={classes.paragraphAct}
                            paragraph
                          >
                            {bulkMessage}  <br/>
                          </Typography>
                          <Alert severity="warning"><AlertTitle>Note Creation Summary</AlertTitle><p>Valid: {bulkSummary?.valid}</p><p>Invalid: {bulkSummary?.invalid}</p></Alert>
                          <br/>
                          <Button
                              color="primary"
                              variant="contained"
                              className={classes.paragraphButton}
                              disabled={(bulkSummary?.valid || 0) <= 0}
                              onClick={(event) => {
                                  if(bulkKeyId){
                                    setBackdropLoader(true)
                                    approveNoteCSV(salesOrg, bulkKeyId).then( reply => {
                                      setBackdropLoader(false)
                                     // console.log(reply?.data?.message);
                                      if((reply?.status || 500) < 400){
                                        setBulkSummary(undefined);
                                        setBulkADD(undefined);
                                        setBulkMessage(undefined);
                                        setBulkKeyId(undefined);
                                        setSelectedFile(undefined);
										setfileName("");
                                        setAlertLevel({severity:"success"});
                                        setAlertTitle("Saved");
                                        setAlertMessage("Changes saved successfully!");
                                      } else {
                                        setAlertLevel({severity:"error"});
                                        setAlertTitle("Issue saving changes!");
                                        setAlertMessage(`${reply?.data?.message}\n\nPlease reach out to CONA if issue persists.`);
                                      }
                                      setOpenAlertWindow(true);
                                    })
                                  }
                                }
                              }
                            ><Save/> Apply Changes
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                  ):((bulkMessage && bulkErrorBody)?(
                    <Grid item xs={12} md={12} xl={12}>
                      <Card className={classes.card}>
                        <CardContent>
                          <Typography variant="h5" className={classes.paragraph}>
                            Could not process file
                          </Typography>
                          <Alert severity="error">
                            <AlertTitle>Error</AlertTitle>   
                            {bulkMessage} 
                          </Alert>
                          {(bulkErrorBody.duplicateCustomerNums)?(<Alert severity="warning"><AlertTitle>Duplicate Customer(s)</AlertTitle>{(bulkErrorBody.duplicateCustomerNums).join(', ')}</Alert>) : (<div></div>)}
                        </CardContent>
                      </Card>
                    </Grid>
                ):(<div></div>))}
        
      {
          (!bulkErrorBody && bulkADD)?( /* Upload Detected */ 
            <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
              <Card className={classes.card}>
                  <TableAbstraction
                  settingsKey="ADM_BN"
                  options={{
                    draggableColumns: {
                      enabled: true,
                    },
                    serverSide: false,
                    selectableRows: "none",
                  }}
                  title="Modifications"
                  columns={[ // salesOffice:string, bankID: string, bankName: string, customerNum:string, change:string
                    {
                      label: "Sales Office",
                      name: "sales_office",
                      options: {
                        filter: true,
                        customBodyRender: (value: any) => (value)?(`${value} - ${determineConfig(codes, "SALESOFFICES", value)}`):('') ,
                      },
                    },
                    {
                      label: "Customer Number",
                      name: "customer_num",
                      options: {
                        searchable: true,
                        filter: false,
                      },
                    },
                    {
                      label: "Customer Name",
                      name: "name1",
                      options: {
                        searchable: true,
                        filter: false,
                      },
                    },
                    {
                      label: "Note Type",
                      name: "note_type",
                      options: {
                        searchable: true,
                        filter: false,
                      },
                    },
                    {
                      label: "Valid Until",
                      name: "valid_until_dt",
                      options: {
                        searchable: true,
                        filter: false,
                      },
                    },
                    {
                      label: "Note",
                      name: "text",
                      options: {
                        searchable: true,
                        filter: false,
                      },
                    },
                    {
                      label: "Valid",
                      name: "Valid",
                      options: {
                        searchable: true,
                        filter: true,
                        customBodyRender: (value: any) => { return (value === 'Yes')?(<AddCircle  style={{color: "Green" }}/>):(<RemoveCircle style={{color: "Red" }}/>)},
                      },
                    },
                  ]}
                  data={bulkADD}
                />
              </Card>
            </Grid>
          ):(/* No Changes To Show */<div></div>)
      }
      </Grid>
      <Modal
        open={openAlertWindow}
        onClose={handleModalClose}
      >
        <div style={modalStyle} className={classes.paper} >
                <Alert severity={alertLevel.severity}>
                    <AlertTitle>{alertTitle}</AlertTitle>
                    {alertMessage}
                    <div style={{ paddingRight: "5px", textAlign:"right"}}>
                      <React.Fragment>
                        <Tooltip title={"Close"}>
                            <IconButton onClick={handleModalClose}>
                              <Clear />
                            </IconButton>
                        </Tooltip>
                      </React.Fragment>
                    </div>
                </Alert>
                  
        </div>
      </Modal>
    </div>
    ) : (
          <Alert severity="error">
            <AlertTitle><Lock/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Bulk Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
  );
}